import type { ModelRaw } from '@/types'
import type StripoPrebuiltTemplate from '@/data/models/domain/stripo/StripoPrebuiltTemplate'

export const enum StripoPrebuiltTemplateType {
  BASIC = 'BASIC',
  FREE = 'FREE',
  PREMIUM = 'PREMIUM',
}

export type StripoPrebuiltTemplatesFetchParams = {
  type: StripoPrebuiltTemplateType
  sort: 'NEW' | 'ACTUAL'
  limit?: number
  page?: number
  templateTypes?: unknown
  templateIndustries?: unknown
  templateFeatures?: unknown
  templateSeasons?: unknown
}

export type StripoPrebuiltTemplateApiResponse = Omit<ModelRaw<StripoPrebuiltTemplate>, 'id'> & { templateId: string }

export type StripoPrebuiltTemplatesFetchResponse = {
  data: StripoPrebuiltTemplateApiResponse[]
  total: number
}

export enum StripoPrebuiltSimpleTemplateType {
  All = 'all',
  TextOnly = 'textOnly',
  TextImage = 'textAndImage',
}

export type StripoPrebuiltSimpleTemplatesFetchParams = {
  type: StripoPrebuiltSimpleTemplateType
  limit?: number
  page?: number
}
